module.exports = __webpack_public_path__ + "img/day.307c61b5.svg";